import { Grid, Stack, Typography, useTheme } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { hyperMonitoringTypes } from 'constants/hyper-monitoring.constants';
import { pagesEnum } from 'constants/ui.constants';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { getHyperMonitoringAnalytics } from 'services/hyper-monitoring.service';
import { getHyperMonitoringAnalyticsData } from 'state/reducers/hyper-monitoring.reducer';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { OrangeCircle } from 'theme/elements/Chips';
import { SmallCard } from 'theme/elements/Cards';

export const HyperMonitoring = () => {
	const theme = useTheme();
	const t = useAppSelector(selectTranslations);
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const analytics = useAppSelector(getHyperMonitoringAnalyticsData);
	const card = analytics.data.beneficiariesRequests;

	useEffect(() => {
		dispatch(getHyperMonitoringAnalytics());
	}, [dispatch]);

	const handleCardClick = () => {
		navigate(`/${pagesEnum.HYPER_MONITORING}/${hyperMonitoringTypes.BENEFICIARIES}`);
	};

	return (
		<Stack>
			<Typography variant="h4" sx={{ fontWeight: 700, color: theme.palette.common.black, marginBottom: 2 }}>
				{t('page.dashboard.hyperMonitoring.title')}
			</Typography>
			<Grid container spacing={4} columns={5}>
				<Grid item xs={8} sm={'auto'} sx={{ cursor: 'pointer' }}>
					<SmallCard
						styleObj={{
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'space-between',
						}}
						handleClick={handleCardClick}
					>
						<Stack>
							<Typography variant="boldBody3">{card.total}</Typography>
							<Stack direction="row" alignItems="center" spacing={1}>
								{card.today > 0 && <OrangeCircle />}
								<Typography variant="boldBody4" sx={{ fontWeight: card.today > 0 ? 700 : 'auto' }}>
									{t('page.dashboard.hyperMonitoring.beneficiariesRequests')}
								</Typography>
							</Stack>
						</Stack>
						<img src="/icons/arrow-left.svg" alt="" style={{ marginRight: '10px' }} />
					</SmallCard>
				</Grid>
			</Grid>
		</Stack>
	);
};
